import Tabs from "@/components/Tabs";
import { Path, useNavigate } from "@/router";
import { useLocation, useParams } from "react-router-dom";
import React from "react";

export default function InternshipsTabLayout({ children }: { children: React.ReactNode }) {
  const { universityId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const tabItems = [
    {
      label: "Current Students Internships",
      to: `/education/universities/${universityId}/internships/current` as const
    },
    {
      label: "Alumni Internships",
      to: `/education/universities/${universityId}/internships/alumni` as const
    }
  ];

  return (
    <>
      <Tabs
        tabItems={tabItems.map(({ label, to }) => ({
          label,
          onClick: () => navigate(to as unknown as Path),
          active: location.pathname.startsWith(to)
        }))}
      />
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
